module.exports = __webpack_public_path__ + "static/media/community-gardens-gallery-10.5d588d96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/community-gardens-gallery-10.jpg
// module id = 682
// module chunks = 13